import React, { Component } from "react";
import DateInput from "app/common/components/input/Date";
export default class DateColumnEditor extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const dateFormat = this.props.colDef?.cellRendererParams?.columnOptions[
      "format"
    ];
    const isDateTime =
      this.props.colDef?.cellRendererParams?.columnTypeId === "4"
        ? false
        : true;
    const rowHeight = this.props?.node?.rowHeight;

    return (
      <DateInput
        value={this.props.value}
        isDateTime={isDateTime}
        format={dateFormat}
        isPickerOpenByDefault={true}
        underLine={false}
        isFormattedDate={true}
        saveOnEnter={true}
        className={true}
        autoFocus={true}
        onChange={this.props.onChange}
        propsApi={this.props.api}
        rowHeight={rowHeight}
      />
    );
  }
}
